import type { TreeTag } from '#domains/tags/types';

export type OptimisticCreatePayload = {
  tag: TreeTag;
  parentId?: string;
};

export const optimisticCreate = (
  state: TreeTag[],
  { tag, parentId }: OptimisticCreatePayload
) => {
  tag = { ...tag, hasChildren: false, open: false };

  if (!parentId) {
    return [{ ...tag, level: 0 }, ...state];
  }
  return state.flatMap(t => {
    if (t.id === parentId) {
      if (!t.open) {
        return t;
      }
      return [t, { ...tag, level: t.level + 1, parentId: t.id }];
    }
    return t;
  });
};
